<template>
  <el-row :gutter="20" class="panel-group d-block mt-5">
    <el-col :xs="12" :sm="12" :lg="8" class="py-2">
      <el-card shadow="hover" :body-style="{ padding: 0 }" class="border-0">
        <div class="card-panel d-md-flex d-block p-2">
          <div class="card-panel-icon-wrapper icon-total p-2 text-center">
            <i class="fa fa-users" style="font-size: 50px;"></i>
          </div>
          <div class="ml-0 ml-md-2">
            <div class="text-muted font-weight-bold mb-2 text-center">
              网站总访问量
            </div>
            <div class="text-info font-weight-bold text-center text-md-left">
              <count-to
                :start-val="0"
                :end-val="countData.totalVisits"
                :duration="2600"
              />
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="8" class="py-2">
      <el-card shadow="hover" :body-style="{ padding: 0 }" class="border-0">
        <div class="card-panel d-md-flex d-block p-2">
          <div class="card-panel-icon-wrapper game-total p-2 text-center">
            <i class="fa fa-gamepad" style="font-size: 50px;width: 54px;"></i>
          </div>
          <div class="ml-0 ml-md-2">
            <div class="text-muted font-weight-bold mb-2 text-center">
              游戏总量
            </div>
            <div class="text-success font-weight-bold text-center text-md-left">
              <count-to
                :start-val="0"
                :end-val="countData.gameTotal"
                :duration="3000"
              />
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="8" class="py-2">
      <el-card shadow="hover" :body-style="{ padding: 0 }" class="border-0">
        <div class="card-panel d-md-flex d-block p-2">
          <div class="card-panel-icon-wrapper icon-people p-2 text-center">
            <i class="fa fa-android" style="font-size: 50px;width: 54px;"></i>
          </div>
          <div class="ml-0 ml-md-2">
            <div class="text-muted font-weight-bold mb-2 text-center">
              安卓总下载量
            </div>
            <div class="text-success font-weight-bold text-center text-md-left">
              <count-to
                :start-val="0"
                :end-val="countData.androidDownloads"
                :duration="3000"
              />
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="8" class="py-2">
      <el-card shadow="hover" :body-style="{ padding: 0 }" class="border-0">
        <div class="card-panel d-md-flex d-block p-2">
          <div class="card-panel-icon-wrapper icon-message p-2 text-center">
            <i class="fa fa-apple" style="font-size: 50px;width: 54px;"></i>
          </div>
          <div class="ml-0 ml-md-2">
            <div class="text-muted font-weight-bold mb-2 text-center">
              IOS总点击量
            </div>
            <div class="text-danger font-weight-bold text-center text-md-left">
              <count-to
                :start-val="0"
                :end-val="countData.iosClicks"
                :duration="3000"
              />
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="8" class="py-2">
      <el-card shadow="hover" :body-style="{ padding: 0 }" class="border-0">
        <div class="card-panel d-md-flex d-block p-2">
          <div class="card-panel-icon-wrapper icon-money p-2 text-center">
            <i class="fa fa-newspaper-o" style="font-size: 50px;"></i>
          </div>
          <div class="ml-0 ml-md-2">
            <div class="text-muted font-weight-bold mb-2 text-center">
              新闻总浏览量
            </div>
            <div class="text-warning font-weight-bold text-center text-md-left">
              <count-to
                :start-val="0"
                :end-val="countData.newsViews"
                :duration="3200"
              />
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="8" class="py-2">
      <el-card shadow="hover" :body-style="{ padding: 0 }" class="border-0">
        <div class="card-panel d-md-flex d-block p-2">
          <div class="card-panel-icon-wrapper icon-shopping p-2 text-center">
            <i class="fa fa-address-card" style="font-size: 50px;"></i>
          </div>
          <div class="ml-0 ml-md-2">
            <div class="text-muted font-weight-bold mb-2 text-center">
              职位总浏览量
            </div>
            <div class="text-primary font-weight-bold text-center text-md-left">
              <count-to
                :start-val="0"
                :end-val="countData.jobViews"
                :duration="3600"
              />
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import CountTo from "vue-count-to";

export default {
  data() {
    return {
      countData: {
        totalVisits: 0
      }
    };
  },
  components: {
    CountTo
  },
  mounted() {
    this.getCountData();
  },
  methods: {
    getCountData() {
      this.axios.get("/siteLog/countData").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.countData = resp.data.data;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.panel-group {
  /*margin-top: 18px;*/
  .card-panel {
    border-radius: 4px;
    background-color: #ffffff;

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
        border-radius: 4px;
      }

      .icon-total {
        background: #17a2b8;
      }
      .game-total {
        background: #6c757d;
      }
      .icon-people {
        background: #67c23a;
      }

      .icon-message {
        background: #f56c6c;
      }

      .icon-money {
        background: #e6a23c;
      }

      .icon-shopping {
        background: #3888fa;
      }
    }

    .icon-total {
      color: #17a2b8;
    }

    .game-total {
      color: #6c757d;
    }

    .icon-people {
      color: #67c23a;
    }

    .icon-message {
      color: #f56c6c;
    }

    .icon-money {
      color: #e6a23c;
    }

    .icon-shopping {
      color: #3888fa;
    }
  }
}
</style>
